export class UTCDate {
  public static getDate(day: number = 0) {
    const newDate = new Date();
    return new Date(newDate.getUTCFullYear(), newDate.getUTCMonth(), newDate.getUTCDate() + day);
  }

  public static compareWithTime(date1: Date, date2: Date) {
    return date2.getTime() - date1.getTime();
  }
  public static compareWithoutTime(date1: Date, date2: Date) {
    const d1 = new Date(date1.getUTCFullYear(), date1.getUTCMonth(), date1.getUTCDate());
    const d2 = new Date(date2.getUTCFullYear(), date2.getUTCMonth(), date2.getUTCDate());
    return d2.getTime() - d1.getTime();
  }
}
